import script from "./GeneralMapSubtitle.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralMapSubtitle.vue?vue&type=script&setup=true&lang=js"

import "./GeneralMapSubtitle.vue?vue&type=style&index=0&id=15970144&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15970144"]])

export default __exports__